










































import { Component, Vue, Prop } from 'vue-property-decorator';
import { AuthParams } from '@/models/userdata/authparams';

@Component
export default class VerifyAccountForm extends Vue {
  @Prop({ default: () => {} }) onContinue;
  @Prop({ default: new AuthParams() }) authParams;
  @Prop() errors;
}
